import { reactive } from "vue";
const context = reactive({})

/**
 * 
 * @param String name 
 * @param {format:Function} config 
 * @returns 
 */
export const defineColumnFormat = (name, config = { format: (v) => { return v } }) => {
    if (!name) {
        return
    }
    context[name] = config
}

export const getColumnFormat = (name) => {
    return context[name]
}